<template>
    <div id="lattestSettlementTabs">
        <ejs-tab id="element" ref="lattestSettlementTabs" :selected="onTabSelected">
            <e-tabitems>
                <e-tabitem :header='headerText0' :content="energyFuture"></e-tabitem>
                <e-tabitem v-if="hasEnergyLogsPermission" :header='headerText3' :content="energyFuturesLogs"></e-tabitem>
                <e-tabitem :header='headerText1' :content="fxRate"></e-tabitem>
                <e-tabitem v-if="hasFxLogsPermission" :header='headerText4' :content="fxRateLogs"></e-tabitem>
                <!--<e-tabitem :header='headerText2' :content="other"></e-tabitem>
                <e-tabitem :header='headerText5' :content="otherLogs"></e-tabitem>-->
                <e-tabitem :header='headerText6' :content="derived"></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>
<script>import Vue from "vue";
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import EnergyFutures from '@/views/markets/MarketPricing.vue';
    import EnergyFuturesLogs from '@/views/markets/MarketPricingLogs.vue';
    import FxRate from '@/views/markets/FXRate.vue';
    import FxRateLogs from '@/views/markets/FXRateLogs.vue';
    import Other from '@/views/markets/OtherMarketInstruments.vue';
    import OtherLogs from '@/views/markets/OtherMarketInstrumentsLogs.vue';
    import Derived from '@/views/markets/Derived.vue';

    Vue.use(TabPlugin);
    export default Vue.extend({
        name: 'lattestSettlementTabs',
        computed: {
            hasEnergyLogsPermission() {
                return this.$store.state.permissions["Permissions.EnergyLogs.View"];
            },
            hasFxLogsPermission() {
                return this.$store.state.permissions["Permissions.FXLogs.View"];
            }
        },
        data: function() {
            return {
                headerText0: { text: 'Energy Futures' },
                headerText1: { text: 'FX' },
                //headerText2: { text: 'Other' },
                headerText3: { text: 'Energy Futures Logs' },
                headerText4: { text: 'FX Logs' },
               // headerText5: { text: 'Other Logs' },
                headerText6: { text: 'Derived' },
                energyFuture: function () {
                    return {
                        template: {
                            extends: EnergyFutures
                        }
                    }
                },
                energyFuturesLogs: function () {
                    return {
                        template: {
                            extends: EnergyFuturesLogs
                        }
                    }
                },
                fxRate: function () {
                    return {
                        template: {
                            extends: FxRate
                        }
                    }
                },
                fxRateLogs: function () {
                    return {
                        template: {
                            extends: FxRateLogs
                        }
                    }

                },
                other: function () {
                    return {
                      template: {
                           extends: Other
                        }
                    }
                },
                otherLogs: function () {
                   return {
                       template: {
                           extends: OtherLogs
                       }
                   }
               },
                derived: function () {
                    return {
                        template: {
                            extends: Derived
                        }
                    }
                }
            };
        },
        methods: {
            onTabSelected(args) {
                if (args.selectedIndex == 1 || args.selectedIndex == 3) {
                    this.$refs.lattestSettlementTabs.ej2Instances.vueInstance.refresh();
                }
            }
        },
        mounted: function () {


        },

    });</script>
<style>
    .market-container {
        width: 100%;
        display: flex;
        background-color: white;
        padding-top: 30px;
    }

    .dashboard-seo #marketSummaryLayout.e-dashboardlayout.e-control .e-panel .e-panel-container .e-panel-header {
        border-bottom: 2px solid #e6e9ed !important;
        padding: 10px;
        height: 35px;
        margin: 0 15px 0 15px;
    }

    .dashboard-seo #marketSummaryLayout.e-dashboardlayout .e-panel-content {
        height: calc(100% - 35px) !important;
        overflow: hidden;
        width: 100%;
    }

    #layout_0 {
        width: 492.667px !important;
        background-color: inherit;
        border: none !important;
    }

    #layout_1 {
        width: 492.667px !important;
        left: 489.667px !important;
        background-color: inherit !important;
        border: none !important;
    }

    #layout_2 {
        width: 600px !important;
        left: 979.33px !important;
        background-color: inherit !important;
        border: none !important;
    }

    .e-dashboardlayout.e-control .e-panel {
        box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%) !important;
    }

    .market-crow {
        padding-top: 10px;
    }
</style>